(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["audi-street-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-audi-street-hub]').forEach(function (section) {
    var selector = section.querySelector('[data-selector]'); if (!selector) return;
    var dataNode = selector.querySelector('[data-program-data]'); var modelSelect = selector.querySelector('[data-model-select]'); var generationSelect = selector.querySelector('[data-generation-select]'); var searchButton = selector.querySelector('[data-search-button]'); var message = selector.querySelector('[data-selector-message]'); var programs = [];
    try { programs = JSON.parse(dataNode.textContent).filter(function (item) { return item && item.model && item.generation && item.url; }); } catch (error) { programs = []; }
    function getModelFamily(model) { return model.replace(/^Audi\s+/, '').split(' ')[0]; }
    function getGenerationLabel(item) { var cleanModel = item.model.replace(/^Audi\s+/, ''); var family = getModelFamily(item.model); var chassis = cleanModel.replace(family, '').trim(); return chassis ? chassis + ' ' + item.generation : item.generation; }
    programs.reduce(function (list, item) { var family = getModelFamily(item.model); if (list.indexOf(family) === -1) { list.push(family); var option = document.createElement('option'); option.value = family; option.textContent = family; modelSelect.appendChild(option); } return list; }, []);
    function setMessage(isVisible) { if (!message) return; message.hidden = !isVisible; }
    function setSearchState() { searchButton.disabled = !(modelSelect.value && generationSelect.value); setMessage(false); }
    modelSelect.addEventListener('change', function () { var model = modelSelect.value; var matches = programs.filter(function (item) { return getModelFamily(item.model) === model; }); var placeholder = document.createElement('option'); generationSelect.innerHTML = ''; placeholder.value = ''; placeholder.textContent = generationSelect.getAttribute('data-placeholder') || 'Select body style'; generationSelect.appendChild(placeholder); generationSelect.disabled = !model; matches.forEach(function (item) { var option = document.createElement('option'); option.value = item.url; option.textContent = getGenerationLabel(item); generationSelect.appendChild(option); }); setSearchState(); });
    generationSelect.addEventListener('change', setSearchState);
    searchButton.addEventListener('click', function () { if (generationSelect.value) { window.location.href = generationSelect.value; } else { setMessage(true); } });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bmw-street-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bmw-street-hub]').forEach(function (section) {
    var selector = section.querySelector('[data-selector]');
    if (!selector) return;
    var dataNode = selector.querySelector('[data-program-data]');
    var modelSelect = selector.querySelector('[data-model-select]');
    var generationSelect = selector.querySelector('[data-generation-select]');
    var searchButton = selector.querySelector('[data-search-button]');
    var message = selector.querySelector('[data-selector-message]');
    var programs = [];
    try { programs = JSON.parse(dataNode.textContent).filter(function (item) { return item && item.model && item.generation && item.url; }); } catch (error) { programs = []; }
    function getModelFamily(model) { return model.replace(/^BMW\s+/, '').split(' ')[0]; }
    function getGenerationLabel(item) { var cleanModel = item.model.replace(/^BMW\s+/, ''); var family = getModelFamily(item.model); var chassis = cleanModel.replace(family, '').trim(); return chassis ? chassis + ' ' + item.generation : item.generation; }
    programs.reduce(function (list, item) { var family = getModelFamily(item.model); if (list.indexOf(family) === -1) { list.push(family); var option = document.createElement('option'); option.value = family; option.textContent = family; modelSelect.appendChild(option); } return list; }, []);
    function setMessage(isVisible) { if (!message) return; message.hidden = !isVisible; }
    function setSearchState() { searchButton.disabled = !(modelSelect.value && generationSelect.value); setMessage(false); }
    modelSelect.addEventListener('change', function () { var model = modelSelect.value; var matches = programs.filter(function (item) { return getModelFamily(item.model) === model; }); var placeholder = document.createElement('option'); generationSelect.innerHTML = ''; placeholder.value = ''; placeholder.textContent = generationSelect.getAttribute('data-placeholder') || 'Select generation'; generationSelect.appendChild(placeholder); generationSelect.disabled = !model; matches.forEach(function (item) { var option = document.createElement('option'); option.value = item.url; option.textContent = getGenerationLabel(item); generationSelect.appendChild(option); }); setSearchState(); });
    generationSelect.addEventListener('change', setSearchState);
    searchButton.addEventListener('click', function () { if (generationSelect.value) { window.location.href = generationSelect.value; } else { setMessage(true); } });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rz-specialist-contact-collection"] && !Shopify.designMode) return;
  try {
    
if(!window.rzSpecialistContactValidationPatch){window.rzSpecialistContactValidationPatch=true;document.addEventListener('click',function(event){var submit=event.target&&event.target.closest&&event.target.closest('.rz-specialist-contact-modal__submit');if(!submit)return;var form=submit.closest('.rz-specialist-contact-modal__form');var error=form&&form.querySelector('[data-rz-validation-error]');if(form&&error&&!form.checkValidity()){error.hidden=false;}})}document.querySelectorAll('.rz-specialist-contact__button--request .rz-specialist-contact__icon').forEach(function(icon){icon.remove();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["street-customer-cases"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var scrollButton = event.target.closest('[data-street-case-scroll]');
    if (scrollButton) {
      var scrollSection = scrollButton.closest('.street-customer-cases');
      var rail = scrollSection && scrollSection.querySelector('.street-customer-cases__rail');
      if (rail) {
        var direction = scrollButton.getAttribute('data-street-case-scroll') === 'previous' ? -1 : 1;
        rail.scrollBy({ left: direction * Math.max(rail.clientWidth * 0.8, 280), behavior: 'smooth' });
      }
    }

    var openButton = event.target.closest('[data-street-case-open]');
    if (openButton) {
      var section = openButton.closest('.street-customer-cases');
      var dialog = section && section.querySelector('[data-street-case-dialog="' + openButton.getAttribute('data-street-case-open') + '"]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    }

    var closeButton = event.target.closest('[data-street-case-close]');
    if (closeButton) {
      var closeDialog = closeButton.closest('dialog');
      if (closeDialog) closeDialog.close();
    }

    if (event.target.matches('.street-customer-cases__dialog')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["street-program-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const unique = (items) => [...new Set(items.filter(Boolean))];

    const setOptions = (select, placeholder, values) => {
      select.innerHTML = '';
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);
      values.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
    };

    const pushEvent = (name, payload = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
    };

    const initStreetSection = (section) => {
      if (!section) return;
      if (section.dataset.rzstreetReady === 'true') return;
      section.dataset.rzstreetReady = 'true';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.querySelectorAll('.rzstreet__hero-video').forEach((video) => {
          video.pause();
          video.removeAttribute('autoplay');
        });
      }

      const finder = section.querySelector('[data-street-finder]');
      if (finder) {
        const source = finder.querySelector('[data-street-vehicles]');
        const make = finder.querySelector('[data-finder-make]');
        const model = finder.querySelector('[data-finder-model]');
        const generation = finder.querySelector('[data-finder-generation]');
        const submit = finder.querySelector('[data-finder-submit]');
        const status = finder.querySelector('[data-finder-status]');
        const copy = finder.querySelector('[data-finder-copy]');
        const series = finder.querySelector('[data-finder-series]')?.textContent.trim();
        let vehicles = [];
        let selectedUrl = '';

        try {
          vehicles = JSON.parse(source.textContent)
            .map((item) => ({
              ...item,
              make: String(item.make || '').trim(),
              model: String(item.model || '').trim(),
              generation: String(item.generation || '').trim(),
              series: String(item.series || '').trim(),
              url: String(item.url?.url || item.url || '').trim()
            }))
            .filter((item) => item.series === series);
          setOptions(make, copy.dataset.brand, unique(vehicles.map((item) => item.make)).sort());
        } catch (error) {
          status.textContent = copy.dataset.error;
          make.disabled = true;
        }

        make.addEventListener('change', () => {
          const models = unique(vehicles.filter((item) => item.make === make.value).map((item) => item.model)).sort();
          setOptions(model, copy.dataset.model, models);
          setOptions(generation, copy.dataset.generation, []);
          model.disabled = !make.value || models.length === 0;
          generation.disabled = true;
          submit.disabled = true;
          selectedUrl = '';
          status.textContent = models.length || !make.value ? '' : copy.dataset.unavailable;
          if (make.value) pushEvent('street_finder_make', { vehicle_make: make.value });
        });

        model.addEventListener('change', () => {
          const generations = unique(vehicles.filter((item) => item.make === make.value && item.model === model.value).map((item) => item.generation)).sort();
          setOptions(generation, copy.dataset.generation, generations);
          generation.disabled = !model.value || generations.length === 0;
          submit.disabled = true;
          selectedUrl = '';
          status.textContent = generations.length || !model.value ? '' : copy.dataset.unavailable;
          if (model.value) pushEvent('street_finder_model', { vehicle_make: make.value, vehicle_model: model.value });
        });

        generation.addEventListener('change', () => {
          const selected = vehicles.find((item) => item.make === make.value && item.model === model.value && item.generation === generation.value);
          selectedUrl = selected?.url || '';
          submit.disabled = !selectedUrl;
          status.textContent = selectedUrl ? copy.dataset.ready : (generation.value ? copy.dataset.unavailable : '');
          if (generation.value) pushEvent('street_finder_generation', { vehicle_make: make.value, vehicle_model: model.value, vehicle_generation: generation.value });
        });

        submit.addEventListener('click', () => {
          if (!selectedUrl) return;
          pushEvent('street_finder_submit', { vehicle_make: make.value, vehicle_model: model.value, vehicle_generation: generation.value, destination: selectedUrl });
          window.location.assign(selectedUrl);
        });
      }

      const rail = section.querySelector('[data-build-rail]');
      if (rail) {
        const prev = section.querySelector('[data-build-prev]');
        const next = section.querySelector('[data-build-next]');
        const progress = section.querySelector('[data-build-progress]');
        const move = (direction) => rail.scrollBy({ left: rail.clientWidth * 0.76 * direction, behavior: 'smooth' });
        const updateProgress = () => {
          const max = rail.scrollWidth - rail.clientWidth;
          const ratio = max > 0 ? rail.scrollLeft / max : 0;
          const visible = rail.scrollWidth > 0 ? Math.min(1, rail.clientWidth / rail.scrollWidth) : 1;
          if (progress) progress.style.transform = `scaleX(${visible + ratio * (1 - visible)})`;
        };
        prev?.addEventListener('click', () => move(-1));
        next?.addEventListener('click', () => move(1));
        rail.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress, { passive: true });
        updateProgress();
      }

      section.querySelectorAll('[data-program-position]').forEach((card) => card.addEventListener('click', () => pushEvent('street_program_open', { position: card.dataset.programPosition, destination: card.href })));
      section.querySelectorAll('[data-build-dialog-open]').forEach((card) => {
        card.addEventListener('click', () => {
          const dialog = document.getElementById(card.dataset.buildDialogOpen);
          if (!dialog || typeof dialog.showModal !== 'function') return;
          dialog.showModal();
          pushEvent('street_build_open', { position: card.dataset.buildPosition, case_handle: card.dataset.buildCase });
        });
      });

      section.querySelectorAll('[data-case-dialog]').forEach((dialog) => {
        dialog.querySelector('[data-case-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });

      const factoryVideo = section.querySelector('[data-factory-video]');
      const factoryPlay = section.querySelector('[data-factory-play]');
      if (factoryVideo && factoryPlay) {
        factoryPlay.addEventListener('click', async () => {
          try {
            if (factoryVideo.paused) {
              await factoryVideo.play();
              factoryVideo.classList.add('is-playing');
              factoryPlay.textContent = 'PAUSE FILM';
              pushEvent('street_factory_film_play');
            } else {
              factoryVideo.pause();
              factoryPlay.textContent = 'WATCH THE FILM';
            }
          } catch (error) {
            factoryVideo.setAttribute('controls', '');
          }
        });
      }

      const advisorDialog = section.querySelector('[data-advisor-dialog]');
      section.querySelector('[data-advisor-open]')?.addEventListener('click', () => {
        if (!advisorDialog || typeof advisorDialog.showModal !== 'function') return;
        advisorDialog.showModal();
        pushEvent('street_advisor_open');
      });
      advisorDialog?.querySelector('[data-advisor-close]')?.addEventListener('click', () => advisorDialog.close());
      advisorDialog?.addEventListener('click', (event) => {
        if (event.target === advisorDialog) advisorDialog.close();
      });

      section.querySelectorAll('.rzstreet__advisor-channel[href]').forEach((link) => {
        link.addEventListener('click', () => pushEvent('street_advisor_channel', { channel: link.textContent.trim().toLowerCase() }));
      });
    };

    document.querySelectorAll('[data-rzstreet-section]').forEach(initStreetSection);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches?.('[data-rzstreet-section]')
        ? event.target
        : event.target.querySelector?.('[data-rzstreet-section]');
      initStreetSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
